module.exports = __webpack_public_path__ + "static/media/synth_12.b673686e.mp3";